export default (
  <svg version="1.1" id="Layer_1" x="0px" y="0px" height="100%" width="100%" viewBox="0 0 24.9 67.7">
    <g>
      <path
        d="M12.5,40.6c2.2,0,4.3,0.5,6.2,1.4c2,0.9,3.7,2.2,5.1,3.8c0.7-1.6,1.1-3.4,1.1-5.2c0-1.6-0.3-3.2-1-4.7
		c-0.6-1.5-1.5-2.9-2.7-4c-1.2-1.1-2.5-2.1-4-2.7c-1.5-0.6-3.1-0.9-4.8-0.9c-1.6,0-3.3,0.3-4.8,0.9c-1.5,0.6-2.9,1.5-4,2.7
		c-1.2,1.1-2.1,2.5-2.7,4C0.3,37.3,0,38.9,0,40.6c0,1.8,0.4,3.6,1.1,5.2c1.4-1.6,3.1-3,5.1-3.9C8.2,41,10.3,40.6,12.5,40.6"
      ></path>
      <path
        d="M24.9,55.3c0-2.4-0.7-4.8-2.1-6.9c-1.4-2-3.3-3.6-5.6-4.6C15,43,12.5,42.7,10,43.2c-2.4,0.5-4.6,1.7-6.4,3.4
		c-1.7,1.7-2.9,3.9-3.4,6.3c-0.5,2.4-0.2,4.9,0.7,7.1c0.9,2.3,2.5,4.2,4.6,5.5c2.1,1.4,4.5,2.1,6.9,2.1c3.3,0,6.5-1.3,8.8-3.6
		C23.6,61.7,24.9,58.6,24.9,55.3"
      ></path>
      <path
        d="M24.9,12.4c0-2.4-0.7-4.8-2.1-6.9c-1.4-2-3.3-3.6-5.6-4.6C15,0,12.5-0.2,10,0.2C7.6,0.7,5.4,1.9,3.7,3.6
		C1.9,5.4,0.7,7.6,0.2,10c-0.5,2.4-0.2,4.9,0.7,7.1s2.5,4.2,4.6,5.6c2.1,1.4,4.5,2.1,6.9,2.1c3.3,0,6.5-1.3,8.8-3.6
		C23.6,18.8,24.9,15.6,24.9,12.4"
      ></path>
    </g>
  </svg>
);
